import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Paper, Typography, Chip, Stack, Button } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import { loadPortalData, markNotificationRead } from '../slices/portalSlice';
import { severityChipSx, severityLabel, formatRelativeTime } from '../../utils/severity';
import { tokens } from '../../theme/theme';

export default function PortalNotificationsPage() {
  const dispatch = useDispatch();
  const { notifications } = useSelector((s) => s.portal);

  useEffect(() => { dispatch(loadPortalData()); }, [dispatch]);

  return (
    <Box>
      <PageHeader title="Threat Notifications" subtitle="Security events and updates relevant to your account" />

      <Stack spacing={1.4}>
        {notifications.map((n) => (
          <Paper key={n.id} sx={{ p: 2, borderColor: n.read ? tokens.border : tokens.brand.dim }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, mb: 0.6 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {!n.read && <Box sx={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: tokens.brand.main, flexShrink: 0 }} />}
                <Typography sx={{ fontSize: '0.86rem', color: tokens.text.primary, fontWeight: n.read ? 400 : 600 }}>{n.title}</Typography>
              </Box>
              <Chip label={severityLabel(n.severity)} size="small" sx={{ ...severityChipSx(n.severity), flexShrink: 0 }} />
            </Box>
            <Typography sx={{ fontSize: '0.8rem', color: tokens.text.secondary, mb: 1 }}>{n.detail}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="caption" sx={{ color: tokens.text.muted }}>{formatRelativeTime(n.timestamp)}</Typography>
              {!n.read && (
                <Button size="small" onClick={() => dispatch(markNotificationRead(n.id))} sx={{ fontSize: '0.72rem' }}>
                  Mark as read
                </Button>
              )}
            </Box>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
}
